import { Link, createFileRoute } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SharedDocumentView } from '../../features/my-files/share/shared-document-view';

/**
 * Mở một tài liệu người khác chia sẻ **cho mình** (APM-SHR-c/d) — từ mục "Được chia sẻ với tôi"
 * của trang Tệp. Khác `/s/$token`: lượt cấp quyền gắn với người, nên luôn cần đăng nhập.
 */
export const Route = createFileRoute('/_app/shared/$grantId')({ component: SharedGrantPage });

function SharedGrantPage(): ReactNode {
  const { t } = useTranslation();
  const { grantId } = Route.useParams();
  return (
    <div className="flex flex-col gap-3">
      <Link
        to="/files"
        search={{ shared: true }}
        className="inline-flex w-fit items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ChevronLeft aria-hidden className="size-4" />
        {t('myFiles.shared.folder')}
      </Link>
      <SharedDocumentView target={{ kind: 'grant', grantId }} />
    </div>
  );
}
